import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { DocumentoDetalleService } from 'src/app/services/documento-detalle.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MotivoDevolucionService } from 'src/app/services/motivo-devolucion.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'
import { DocumentoService } from 'src/app/services/documento.service';

@Component({
  selector: 'app-devolucion-mercaderia-modal-devolver-producto',
  templateUrl: './modal-devolver-producto.component.html',
  styleUrls: ['../devolucion-mercaderia.component.scss'],
  providers: [SecurityService]
})
export class DevolucionMercaderiaModalDevolverProductoComponent implements OnInit {

  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
  // Modales
  @ViewChild('devolverProduc', { static: true }) devolverProducModal: ModalDirective;

  optionsMotivo: Array<any> = [];
  processing: boolean = false

  @Input() optionsMotivoGeneral: any[]
  motivoGeneral = null

  // Form
  // formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  loading: boolean = false
  listaProductos: Array<any> = null
  listaProductosAll: Array<any> = null
  documento: any = null
  recorrido: any = null
  paginationContext: PaginationContext = new PaginationContext()
  fechaEmision: any = null

  // Utils
  private log: any
  nroFolioDoc: number = 0;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private motivoDevolucionService: MotivoDevolucionService,
    private documentoDetalleService: DocumentoDetalleService,
    private documentoService: DocumentoService
  ) {
    this.log = this.clog.log('DEVOLVER-PRODUCTO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.loadMotivoDevolucionEspecifico()
    // this.createForm()
  }

  private loadMotivoDevolucionEspecifico() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      activo: true
    }
    this.motivoDevolucionService.GetMotivoDevolucionEspecifico2(inputParams, ({ respuesta }) => {
      const { registros } = respuesta

      this.optionsMotivo = registros.map(tipo => ({ value: tipo.codigo, label: tipo.descripcion, ...tipo }))
    })
  }

  // private createForm() {
  //   this.formHeader = this.fb.group({
  //     motivo: [null, [Validators.required]]
  //   });
  // }

  show(recorrido, documento, fecha) {
    this.nroFolioDoc = documento.folio;
    this.motivoGeneral = null
    this.recorrido = recorrido
    this.documento = documento
    this.fechaEmision = fecha
    this.processing = false
    this.buscar(1)
    this.devolverProducModal.show()
  }

  buscar(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber

    this.listaProductos = []
    this.listaProductosAll = []

    const inputParams =
    {
      rut_emisor: this.rutEmpresa,
      tipo_dte_codigo: this.documento.tipo_dte_codigo,
      folio: this.documento.folio,
      paginaActual: 1, //this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 // this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.documentoDetalleService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta

      // // TODO: DELETE ME
      // registros.push({
      //   sku: 10,
      //   descripcion_producto: 'producto 1',
      //   cantidad: 1235,
      //   formato_codigo: 'CJ6',
      //   monto_total: 400000,
      //   motivo_devolucion_especifico_codigo: 1
      // })
      // registros.push({
      //   sku: 34543,
      //   descripcion_producto: 'producto 2',
      //   cantidad: 35,
      //   formato_codigo: 'CJ12',
      //   monto_total: 34990,
      //   motivo_devolucion_especifico_codigo: 0
      // })
      // registros.push({
      //   sku: 345563,
      //   descripcion_producto: 'producto 3',
      //   cantidad: 400,
      //   formato_codigo: 'UNID',
      //   monto_total: 120000,
      //   motivo_devolucion_especifico_codigo: null
      // })


      this.paginationContext.RecordsCount = registros.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1 // paginaActual
      this.listaProductosAll = registros

      this.listaProductosAll.forEach(producto => {
        producto.additionalData = {
          devolucion: 0, // producto.cantidad,
          devolucionValid: true,
          motivo_devolucion_especifico_codigoValid: producto.motivo_devolucion_especifico_codigo && producto.motivo_devolucion_especifico_codigo > 0
        }
      })

      console.log("devolver producto ", this.listaProductosAll)

      this.loading = false

      this.showPage(this.paginationContext.CurrentPage)
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaProductos = _.slice(this.listaProductosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
    // this.log(this.listaProductosAll.map(p => ({ motivo_devolucion_especifico_codigo: p.motivo_devolucion_especifico_codigo, devolucion: p.additionalData.devolucion })))
  }

  devolucionChange(producto, newDevolucion) {
    // this.log(producto, newDevolucion)
    if (producto.additionalData.devolucion.toString().length === 0) {
      producto.additionalData.devolucionValid = true
      return
    }
    producto.additionalData.devolucion = Number(producto.additionalData.devolucion)
    producto.additionalData.devolucionValid = producto.cantidad >= producto.additionalData.devolucion && producto.additionalData.devolucion >= 0
  }

  motivoEspecificoChange(producto, newMotivoEspecifico) {
    // this.log(producto, newMotivoEspecifico)
    producto.additionalData.motivo_devolucion_especifico_codigoValid =
      producto.motivo_devolucion_especifico_codigo
      && producto.motivo_devolucion_especifico_codigo !== 0
      && producto.motivo_devolucion_especifico_codigo !== '0'
  }

  motivoGeneralChange(motivoGen, listaProductos: any) {
    this.log('Cambio del Especifico', JSON.stringify(motivoGen))
    this.listaProductosAll.forEach(pro => {
      if (pro.additionalData.devolucion > 0) {
        pro.motivo_devolucion_especifico_codigo = motivoGen
        pro.additionalData.devolucionValid = true,
        pro.additionalData.motivo_devolucion_especifico_codigoValid = motivoGen
      }
    })
  }

  devolverProducto() {
    this.log('listaProductos', this.listaProductos)
    this.log('documento', this.documento)
    // this.formValidatorsService.validate(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    if (!this.motivoGeneral) {
      this.toastService.warning('Seleccione un motivo')
      return
    }

    let existeDevolucion: boolean = false
    for (let i = 0; i < this.listaProductosAll.length; i++) {
      const producto = this.listaProductosAll[i]
      if (producto.additionalData.devolucion <= 0)
        continue;
      if (!producto.additionalData.devolucionValid) {
        this.toastService.warning('Existe una cantidad no válida')
        return
      }
      if (!producto.additionalData.motivo_devolucion_especifico_codigoValid) {
        this.toastService.warning('Existe un motivo no válido')
        return
      }
      existeDevolucion = true
    }

    if (!existeDevolucion)
      this.toastService.info('No ha seleccionado ningún producto')

    // Clone product list and delete unnecessary data
    const productList = _.cloneDeep(this.listaProductosAll.filter(p => p.additionalData.devolucion > 0))
    productList.forEach(producto => {
      producto.cantidad = producto.additionalData.devolucion
      if (producto.additionalData.devolucion > 0)
        producto.seleccion = true
      delete producto.additionalData
      delete producto.__typename
      // devolucion: 0, // producto.cantidad,
      // devolucionValid: true,
      // motivo_devolucion_especifico_codigoValid: producto.motivo_devolucion_especifico_codigo && producto.motivo_devolucion_especifico_codigo > 0
    })

    const { codigo, rut_empresa, sucursal_codigo } = this.recorrido
    const { tipo_dte_codigo, folio } = this.documento
    const inputParams = {
      nroRec: codigo,
      motivoDevolucion: this.motivoGeneral, //productList[0].motivo_devolucion_especifico_codigo, // TODO: No me queda claro!
      rutEmisor: rut_empresa,
      sucursalCodigo: sucursal_codigo,
      tipoDte: tipo_dte_codigo,
      folio: folio,
      detalleRef: productList,
      fechaEmision:this.fechaEmision
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.processing = true
    this.documentoService.devuelveProductos(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        this.processing = false

        if (mensajes.filter(m => m.tipo === "ERROR").length > 0)
          return
      }

      this.toastService.success('Operación realizada')
      this.devolverProducModal.hide()
      this.onSuccess.emit()
      this.processing = false
    })
  }

}
